import { FC, HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { merge } from '../../utils/utility';
import { colorButtonClass } from '../CommonClasses';
import { QuickLinkType } from './links.types';

interface ButtonIconLinkProps extends HTMLAttributes<HTMLDivElement> {
  link: QuickLinkType;
  secondary?: boolean;
}

export const ButtonIconLink: FC<ButtonIconLinkProps> = ({ link, secondary, className }) => {
  const content = (
    <>
      {link.Icon && <link.Icon className="h-8 w-8" />}
      <div>
        <div className="font-semibold text-md">{link.title}</div>
        <div className="font-semibold text-xs">{link.subtitle}</div>
      </div>
    </>
  );

  const classNameToUse = merge(
    className,
    colorButtonClass(secondary),
    'flex gap-3 items-center rounded-md px-4 py-2 text-left'
  );

  if (link.to) {
    if (link.external) {
      return (
        <a target="_blank" href={link.to} className={classNameToUse}>
          {content}
        </a>
      );
    } else {
      return (
        <Link to={link.to} className={classNameToUse}>
          {content}
        </Link>
      );
    }
  } else {
    return (
      <button className={classNameToUse} onClick={link.onClick}>
        {content}
      </button>
    );
  }
};
